module.exports = __webpack_public_path__ + "img/copy.3192b982.svg";